import { ToggleGroup } from '@/components/ui/daisy';
import { QuestionTypeEnum } from '@/models/Question';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { TrueOrFalseOption } from '@/components/question/view/primitives/standard/TrueOrFalseOption';
import { useTrueOrFalseAnswerView } from './useTrueOrFalseAnswerView';

export function TrueOrFalseAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.TRUE_OR_FALSE>,
) {
  const { options, value, handleChange, disabled } =
    useTrueOrFalseAnswerView(props);

  return (
    <ToggleGroup
      value={value}
      onChange={handleChange}
      className="w-full gap-6 rounded-2xl px-4 py-6 flex justify-center flex-wrap"
    >
      {options.map(option => (
        <TrueOrFalseOption
          key={option.value}
          option={option}
          disabled={disabled}
        />
      ))}
    </ToggleGroup>
  );
}
